import { z } from 'zod';

export const IAssetCategoryId = {
  PersonalProperty: 1,
  RealEstate: 2,
  Liabilities: 3,
  Other: 4,
} as const;

export const IAssetCategoryName = {
  [IAssetCategoryId.PersonalProperty]: 'Finanzvermögen',
  [IAssetCategoryId.RealEstate]: 'Immobilien',
  [IAssetCategoryId.Liabilities]: 'Schulden',
  [IAssetCategoryId.Other]: 'Sonstige Vermögenswerte',
} as const;

// export type IAssetCategoryId =
//   (typeof IAssetCategoryId)[keyof typeof IAssetCategoryId];
//
// export type IPersonalPropertyAsset = Extract<
//   IAsset,
//   { idAssetCategory: typeof IAssetCategoryId.PersonalProperty }
// >;
//
// export type IRealEstateAsset = Extract<
//   IAsset,
//   { idAssetCategory: typeof IAssetCategoryId.RealEstate }
// >;
//
// export type ILiabilitiesAsset = Extract<
//   IAsset,
//   { idAssetCategory: typeof IAssetCategoryId.Liabilities }
// >;
//
// export type IOtherAsset = Extract<
//   IAsset,
//   { idAssetCategory: typeof IAssetCategoryId.Other }
// >;

export const AssetCategoryIdSchema = z.union([
  z.literal(IAssetCategoryId.PersonalProperty),
  z.literal(IAssetCategoryId.RealEstate),
  z.literal(IAssetCategoryId.Liabilities),
  z.literal(IAssetCategoryId.Other),
]);

export type IAssetCategoryId = z.infer<typeof AssetCategoryIdSchema>;

export const IAssetCategorySchema = z.object({
  idAssetCategory: z
    .number()
    .refine(val => Object.values(IAssetCategoryId).includes(val as any), {
      message: 'Invalid Asset Category ID',
    }),
  AssetCategory: z.string(),
  description: z.string().nullable(),
});

export type IAssetCategory = z.infer<typeof IAssetCategorySchema>;
